var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('wt-text',_vm._l((_vm.data),function(name,index){return _c('span',{key:index,staticClass:"nav",style:(_vm.isLastNav(index) && 'color:' + _vm.activeColor)},[_vm._v(" "+_vm._s(name)+" "),(!_vm.isLastNav(index))?_vm._t("default",function(){return [_c('span',{staticClass:"nav"},[_vm._v(">")])]}):_vm._e()],2)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }